import { Col, Collapse, CollapseProps, Form, FormInstance, Row, Tabs, TabsProps } from 'antd';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import AccessItemContainer from '../../components/AccessItemContainer';
import FieldUser from '../../components/fieldUser';
import { RootState } from '../../store';
import { ItemType, PermissionCombinationType } from '../../types';
import { GantFieldTeam } from '../form/gantFieldTeam';
import GantFieldUser from '../form/gantFieldUser';
import FieldCountDays from './fieldCountDays';
import FieldCountMaterial from './fieldCountMaterial';
import FieldCountPeople from './fieldCountPeople';
import FieldCountTools from './fieldCountTools';
import FieldEquipmentHours from './fieldEquipmentHours';
import FieldMaterialHours from './fieldMaterialHours';
import FieldValueEquipment from './fieldValueEquipment';
import FieldValueLabour from './fieldValueLabour';
import FieldValueMaterial from './fieldValueMaterial';
import FieldValueOther from './fieldValueOther';
import FieldValueTotal from './fieldValueTotal';

interface ITabsResource {
    form: FormInstance<ItemType>;
    isEditableProject: boolean;
    isHasChildren: boolean;
}

const ACCESS_MONEY: PermissionCombinationType[] = [
    'work-item.all.create',
    'work-item.all.edit',
    'work-item.all.manage',
    'work-item.owner.create',
    'work-item.owner.edit',
    'work-item.owner.manage',
    'work-item.assignee.create',
    // 'work-item.assignee.edit',
    // 'work-item.assignee.manage',
    'work-item.owner.view',
];

const TabsResource: React.FC<ITabsResource> = ({ form, isEditableProject, isHasChildren }) => {
    const getKeyCollapse = (collapseItems: CollapseProps['items']) => collapseItems?.map((col) => col.key) as string[];
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);

    const renderGridForInput = (col1: ReactNode[], col2: ReactNode[], col3: ReactNode[]) => {
        return (
            <Row>
                <Col span={7}>{col1}</Col>
                <Col span={1}></Col>
                <Col span={7}>{col2}</Col>
                <Col span={1}></Col>
                <Col span={8}>{col3}</Col>
            </Row>
        );
    };

    let indexInput = 1;

    const isHasChildrenOrEditable = isHasChildren || !isEditableProject;

    const collapsePeopleItems: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Workers',
            children: (
                <>
                    <GantFieldUser
                        key={indexInput++}
                        label={'Assignee'}
                        name={'assignee'}
                        mode={'multiple'}
                        disabled={!isEditableProject}
                    />
                    {isHasChildren && <GantFieldTeam label={'Team'} name={'assignee'} mode={'multiple'} disabled />}
                    <FieldUser
                        key={indexInput++}
                        label={'Owner'}
                        name={'ownerItemId'}
                        disabled={!isEditableProject}
                        onlyForProject={currentGantItem?.projectId ? [currentGantItem.projectId] : []}
                    />
                </>
            ),
            forceRender: true,
        },
        {
            key: '2',
            label: 'Counts',
            children: renderGridForInput(
                [<FieldCountPeople key={indexInput++} disabled={isHasChildrenOrEditable} />],
                [
                    <FieldCountDays key={indexInput++} disabled={isHasChildrenOrEditable} />,
                    <AccessItemContainer key={indexInput++} accessFor={ACCESS_MONEY} item={currentGantItem}>
                        <FieldValueLabour disabled={isHasChildrenOrEditable} />
                    </AccessItemContainer>,
                ],
                [
                    <AccessItemContainer key={indexInput++} accessFor={ACCESS_MONEY} item={currentGantItem}>
                        <FieldValueTotal key={indexInput++} disabled={isHasChildrenOrEditable} />
                    </AccessItemContainer>,
                    <AccessItemContainer key={indexInput++} accessFor={ACCESS_MONEY} item={currentGantItem}>
                        <FieldValueOther key={indexInput++} disabled={isHasChildrenOrEditable} />,
                    </AccessItemContainer>,
                ],
            ),
            forceRender: true,
        },
    ];

    const collapseEquipmentItems: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Counts',
            children: renderGridForInput(
                [<FieldCountTools key={indexInput++} disabled={isHasChildrenOrEditable} />],
                [<FieldEquipmentHours key={indexInput++} disabled={isHasChildrenOrEditable} />],
                [
                    <AccessItemContainer key={indexInput++} accessFor={ACCESS_MONEY} item={currentGantItem}>
                        <FieldValueEquipment key={indexInput++} disabled={isHasChildrenOrEditable} />
                    </AccessItemContainer>,
                ],
            ),
            forceRender: true,
        },
    ];

    const collapseMaterialItems: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Counts',
            children: renderGridForInput(
                [<FieldCountMaterial key={indexInput++} disabled={isHasChildrenOrEditable} />],
                [<FieldMaterialHours key={indexInput++} disabled={isHasChildrenOrEditable} />],
                [
                    <AccessItemContainer key={indexInput++} accessFor={ACCESS_MONEY} item={currentGantItem}>
                        <FieldValueMaterial key={indexInput++} disabled={isHasChildrenOrEditable} />
                    </AccessItemContainer>,
                ],
            ),
            forceRender: true,
        },
    ];

    const tabsResourcesItems: TabsProps['items'] = [
        {
            key: '1',
            label: 'People',
            children: (
                <Collapse defaultActiveKey={getKeyCollapse(collapsePeopleItems)} ghost items={collapsePeopleItems} />
            ),
            forceRender: true,
        },
        {
            key: '2',
            label: 'Equipment',
            children: (
                <Collapse
                    defaultActiveKey={getKeyCollapse(collapseEquipmentItems)}
                    ghost
                    items={collapseEquipmentItems}
                />
            ),
            forceRender: true,
        },
        {
            key: '3',
            label: 'Material',
            children: (
                <Collapse
                    defaultActiveKey={getKeyCollapse(collapseMaterialItems)}
                    ghost
                    items={collapseMaterialItems}
                />
            ),
            forceRender: true,
        },
    ];

    console.log('tabResources');
    return (
        <Form name="scheduleItemFrom2" layout="vertical" form={form} autoComplete="off">
            <Tabs
                defaultActiveKey="1"
                items={tabsResourcesItems}
                centered
                type="card"
                size={'small'}
                style={{ marginBottom: 40, marginTop: 10 }}
            />
        </Form>
    );
};

export default React.memo(TabsResource);
